module.exports = __webpack_public_path__ + "images/pro/events-bg@2x-8be58760aa5597d257f08b92c0e1ce33.png";